import React, { RefObject, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { easings } from "@apps/mf-overview/src/ts/config";

/**
 * Specification of the delay before the transition is being run, from the point
 * where the in prop is set to true.
 */
const DELAY = 0;

/**
 * Specification of the transition duration in milliseconds.
 */
const DURATION = 500;

/**
 * Simple css transition that'll fade and scale the content into view the first
 * time the page is being opened.
 */
// tslint:disable-next-line variable-name no-reserved-keywords
export function InitialFade(props: {
  in?: boolean;
  children: (ref: RefObject<any>) => React.ReactNode;
}) {
  const transitionTimeout = DELAY + DURATION * 2;
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...props}
      mountOnEnter
      unmountOnExit
      timeout={transitionTimeout}
      classNames="initialFade"
      nodeRef={ref}
    >
      <>
        {props.children(ref)}

        <style jsx global>{`
          .initialFade-enter,
          .initialFade-appear {
            opacity: 0.001;

            /**
                         * Apply background color, so that the initial throbber
                         * will disappear when this element is faded into view.
                         */
            background: #fff;
          }

          .initialFade-enter-active,
          .initialFade-appear-active {
            opacity: 1;

            /**
                         * Force leaving element to stay behind entering elemtn
                         * on safari
                         */
            -webkit-transform: translate3d(0, 0, 100px);

            /** Configura transition */
            transition: opacity ${DURATION}ms linear ${DELAY}ms;
          }

          .initialFade-exit {
            opacity: 1;

            /** Force throbber to go behind the main element */
            z-index: -1;
          }

          .initialFade-exit-active {
            opacity: 0.001;
            transition: opacity 0s linear ${DELAY + DURATION * 2}ms;
          }

          .initialFade-exit-done {
            opacity: 0;
          }
        `}</style>
      </>
    </CSSTransition>
  );
};
